export const LOGIN = 'LOGIN'
export const LOGOUT = 'LOGOUT'
export const MENU_OPEN = '@customization/MENU_OPEN'
export const MENU_TYPE = '@customization/MENU_TYPE'
export const THEME_LOCALE = '@customization/THEME_LOCALE'
export const THEME_RTL = '@customization/THEME_RTL'
export const SNACKBAR_OPEN = '@snackbar/SNACKBAR_OPEN'
export const ACCOUNT_INITIALISE = 'ACCOUNT_INITIALISE'
export const FIREBASE_STATE_CHANGED = 'FIREBASE_STATE_CHANGED'
